var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"d":"M5.3 4.7v14.6a2.25 2.25 0 003.43 1.9l11.67-7.3a2.25 2.25 0 000-3.8L8.73 2.8A2.25 2.25 0 005.3 4.53v.18zm1.5 0a.75.75 0 011.14-.63l11.67 7.3a.75.75 0 010 1.27L7.94 19.93a.75.75 0 01-1.15-.64V4.71z"}})}
var staticRenderFns = []

export { render, staticRenderFns }